export const EN = {
  "nav.home": "Home",
  "nav.about": "About",
  "nav.tokenomics": "Tokenomics",
  "nav.howToBuy": "How To Buy",
  "nav.roadmap": "Roadmap",
  "nav.community": "Community",
  "nav.officialLinks": "Official Links",
  "nav.buy": "Buy $SOLMOO",

  "hero.eyebrow": "$SOLMOO · Solana Memecoin",
  "hero.t1": "BORN TO MOO.",
  "hero.t2": "BUILT TO MOON.",
  "hero.journey": "THE SOLMOO JOURNEY STARTS HERE.",
  "hero.body": "A community driven Solana project built around one simple idea: bring the herd together and see how far we can take it.",
  "hero.buy": "BUY $SOLMOO",
  "hero.telegram": "JOIN TELEGRAM",
  "hero.caLabel": "Contract Address",
  "hero.caValue": "SOLMOO · COMING SOON",
  "hero.copyCa": "Copy CA",
  "hero.comingSoon": "Coming Soon",
  "hero.toastCopied": "Contract address copied!",
  "hero.toastSoon": "CA coming soon — stay tuned on Telegram!",
  "hero.scroll": "Scroll",

  "chart.pair": "SOLMOO / SOL",
  "chart.live": "Live · Dexscreener",
  "chart.notActiveBadge": "Not active rn",
  "chart.notActiveBig": "NOT ACTIVE RN",
  "chart.notActiveBody": "The live chart switches on the moment the contract address drops — real-time price, buys and every single moo as it happens.",
  "stats.price": "Price",
  "stats.mcap": "Market Cap",
  "stats.liquidity": "Liquidity",
  "stats.vol24": "24h Volume",
  "stats.volume24h": "24h Volume",
  "stats.change24": "24h Change",
  "stats.change24h": "24h Change",
  "stats.holders": "Holders",

  "marquee.moo": "MOO",
  "marquee.hold": "HOLD",
  "marquee.moon": "MOON",
  "marquee.toTheMoon": "$SOLMOO TO THE MOON",
  "marquee.noTax": "0% TAX",
  "marquee.lpBurned": "100% LP BURNED",
  "marquee.solSpeed": "SOLANA SPEED",
  "marquee.joinHerd": "JOIN THE HERD",

  "about.eyebrow": "Meet the herd",
  "about.t1": "SOLMOO —",
  "about.t2": "THE HERD IS HERE.",
  "about.body": "Built on Solana. No taxes. No complicated mechanics. Just a community, a meme, and one confident cow.",
  "about.join": "Join the herd. MOO with us.",
  "about.risk": "SOLMOO is a meme coin. Crypto involves significant risk.",
  "about.bornOn": "Born on",
  "about.tax": "Buy / Sell tax",
  "about.lp": "LP",
  "about.supply": "Supply",
  "about.lpValue": "100% Burned",
  "about.badge": "THE HERD LEADER",

  "tokenomics.eyebrow": "Tokenomics",
  "tokenomics.t1": "SIMPLE. FAIR.",
  "tokenomics.t2": "ON-CHAIN.",
  "tokenomics.c1t": "Total Supply",
  "tokenomics.c1s": "$SOLMOO, forever fixed",
  "tokenomics.c1v": "1,000,000,000",
  "tokenomics.c2v": "Solana",
  "tokenomics.c3v": "0% / 0%",
  "tokenomics.c4v": "100% Burned",
  "tokenomics.c2t": "Network",
  "tokenomics.c2s": "Lightning fast, sub-penny fees",
  "tokenomics.c3t": "Tax",
  "tokenomics.c3s": "Zero buy, zero sell tax",
  "tokenomics.c4t": "LP Status",
  "tokenomics.c4s": "Initial liquidity destroyed",
  "tokenomics.c5t": "Contract Address",
  "tokenomics.c5v": "Coming Soon",
  "tokenomics.c5s": "Drops at launch — Copy CA activates automatically",

  "htb.eyebrow": "How to buy",
  "htb.t1": "FOUR STEPS TO",
  "htb.t2": "THE MOON",
  "htb.s1t": "Get a Solana wallet",
  "htb.s1d": "Install Phantom or Solflare as an app or browser extension.",
  "htb.s2t": "Fund with SOL",
  "htb.s2d": "Buy SOL on any exchange and withdraw it to your wallet address.",
  "htb.s3t": "Verify the official CA",
  "htb.s3d": "Copy the $SOLMOO contract address from Official Links — and confirm it matches before every swap.",
  "htb.s4t": "Swap and hold",
  "htb.s4d": "Open Pump.fun or Axiom, paste the verified CA and swap SOL for $SOLMOO.",
  "htb.safetyT": "Safety first:",
  "htb.safetyB": "fake tokens impersonate popular launches. Only trust the contract address and links published on this site — verify before every swap.",
  "htb.field": "Launch day, pick your battlefield:",

  "roadmap.eyebrow": "Roadmap",
  "roadmap.t1": "THE GRAZE",
  "roadmap.t2": "PLAN",
  "roadmap.p1": "Phase 1",
  "roadmap.p1t": "Ignition",
  "roadmap.p2": "Phase 2",
  "roadmap.p2t": "Moon Pasture",
  "roadmap.p3": "Phase 3",
  "roadmap.p3t": "Galactic Bovine",
  "roadmap.inProgress": "In progress",
  "roadmap.upcoming": "Upcoming",
  "roadmap.i1": "SOLMOO website, mascot lore and socials live",
  "roadmap.i2": "Official Telegram and X community open",
  "roadmap.i3": "Pump.fun fair launch with 100% LP burned",
  "roadmap.i4": "CoinGecko and CoinMarketCap applications",
  "roadmap.i5": "Holder community milestones: 1,000 → 10,000",
  "roadmap.i6": "Weekly meme contests and community raids",
  "roadmap.i7": "Explore CEX listing opportunities",
  "roadmap.i8": "Community treasury with public spending polls",
  "roadmap.i9": "SOLMOO NFT collection for early holders",
  "roadmap.i10": "Cross-chain bridge exploration",
  "roadmap.i11": "Tier-1 CEX listing applications",
  "roadmap.i12": "Herd merch drops and IRL meetups",
  "roadmap.footnote": "Roadmap items are community goals, not financial promises — no price or market-cap targets.",

  "official.eyebrow": "Official links",
  "official.t1": "ONE HERD.",
  "official.t2": "ONE HOME.",
  "official.warnT": "These are the ONLY official SOLMOO links and contract address.",
  "official.warnB": "Ignore impostors — the team will never DM you first, ask for funds, or post any other contract address.",
  "official.tgT": "Telegram",
  "official.tgD": "Announcements, herd chat and launch alerts",
  "official.xT": "X (Twitter)",
  "official.xD": "Memes, updates and official moos",
  "official.buyOn": "Buy $SOLMOO on",
  "official.marketNote": "Market / DEX links go live on these platforms the moment the token launches.",
  "official.caLabel": "Contract Address",
  "official.caSoon": "COMING SOON — drops at launch",
  "official.copyCa": "Copy CA",
  "official.comingSoon": "Coming Soon",

  "community.heading": "READY TO MOO?",
  "community.sub": "Join the herd building the loudest, funniest memecoin community on Solana.",
  "community.telegram": "JOIN TELEGRAM 💬",
  "community.buy": "BUY $SOLMOO 🚀",

  "footer.brand": "SOLMOO",
  "footer.slogan": "Born to Moo. Built to Moon.",
  "footer.mhm": "MOO. HOLD. MOON.",
  "footer.telegram": "Telegram",
  "footer.x": "X (Twitter)",
  "footer.disclaimer": "Disclaimer: $SOLMOO is a cryptographic memecoin created for fun and community engagement. Crypto assets carry high market risk — nothing on this site is financial advice.",
  "footer.copyright": "© 2026 SOLMOO Community. All Rights Reserved.",

  "chat.title": "MOO-COW AI",
  "chat.powered": "Powered by Gemini",
  "chat.greeting": "Moo! I'm MOO-COW, the official $SOLMOO mascot. Ask me anything about the token — supply, tax, LP, how to buy. I never predict prices, I just moo.",
  "chat.s1": "What is $SOLMOO?",
  "chat.s2": "How do I buy?",
  "chat.s3": "Is the LP really burned?",
  "chat.placeholder": "Ask the cow…",
  "chat.ask": "Ask the Cow",
  "chat.thinking": "the cow is thinking…",
  "chat.error": "Moo… the pasture connection dropped. Try again in a moment.",

  "intro.skip": "Skip Intro",
};
